import { Box, Stack, Typography } from '@mui/material'
import { DateTimePicker } from '@/components/inputs/DateTimePicker/DateTimePicker'

import { OddsFilters, TypeOption } from '../types'
import { ActionTypeSelector } from './ActionTypeSelector'
import { MarketTypeSelector } from './MarketTypeSelector'
import { PlayersSelector } from './PlayersSelector'

interface OddsDataFiltersProps {
  filters: OddsFilters
  onMarketTypeChange: (value: TypeOption | null) => void
  onPlayersChange: (playerIds: number[]) => void
  onStartDateTimeChange: (date: Date | null) => void
  onEndDateTimeChange: (date: Date | null) => void
  onActionTypeChange: (value: TypeOption[]) => void
  actionTypeOptions?: TypeOption[]
  isActionTypeFilterDisabled?: boolean
}

export const OddsDataFilters = ({
  filters,
  onMarketTypeChange,
  onPlayersChange,
  onStartDateTimeChange,
  onEndDateTimeChange,
  onActionTypeChange,
  actionTypeOptions,
  isActionTypeFilterDisabled
}: OddsDataFiltersProps) => {
  return (
    <Stack
      direction="column"
      gap={1}
      mx={2}
      px={2.5}
      my={2}
      py={2}
      sx={{
        borderRadius: 1.25,
        backgroundColor: ({ palette }) => (palette.mode === 'light' ? '#efefef' : '#333')
      }}
    >
      <Typography fontWeight="bold">Golf Match Analysis</Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
        <MarketTypeSelector value={filters.marketType || null} onChange={onMarketTypeChange} />

        <Box sx={{ flex: '1 1 200px', minWidth: '150px' }}>
          <DateTimePicker
            label="Start Date/Time"
            value={filters.startDateTime}
            onChange={onStartDateTimeChange}
            required
          />
        </Box>

        <Box sx={{ flex: '1 1 200px', minWidth: '150px' }}>
          <DateTimePicker
            label="End Date/Time"
            value={filters.endDateTime}
            onChange={onEndDateTimeChange}
            required
          />
        </Box>

        <Box sx={{ flex: '1 1 200px', minWidth: '150px' }}>
          <ActionTypeSelector
            value={filters.actionType}
            onChange={onActionTypeChange}
            options={actionTypeOptions}
            disabled={isActionTypeFilterDisabled}
          />
        </Box>
      </Box>

      <Box>
        <PlayersSelector
          marketType={filters.marketType?.value || null}
          selectedPlayerIds={filters.players}
          onChange={onPlayersChange}
        />
      </Box>
    </Stack>
  )
}
